import { forwardRef, SyntheticEvent } from "react";

import Icon from "../Icon";
import LoadingIcon from "../LoadingIcon";

import { ButtonVariants, ButtonTypes, IconProps } from "./constants";
import * as styledElements from "./ButtonStyles";

const ButtonIcon = ({
  iconProps,
  isRightIcon,
}: {
  iconProps: IconProps;
  isRightIcon?: boolean;
}) => (
  <styledElements.IconContainer isRightIcon={isRightIcon}>
    <Icon
      src={iconProps.src}
      alt={iconProps.alt}
      iconDimension={iconProps.iconDimension || 19}
    />
  </styledElements.IconContainer>
);

interface ButtonProps {
  label: string;
  leftIconProps?: IconProps;
  rightIconProps?: IconProps;
  onClick?: ((event: SyntheticEvent) => void) | (() => void);
  styleProps?: object;
  variant?: ButtonVariants;
  centerText?: boolean;
  isSmallSize?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  type?: ButtonTypes;
  autoFocus?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    label,
    leftIconProps,
    rightIconProps,
    onClick,
    styleProps,
    variant = ButtonVariants.PRIMARY,
    centerText,
    isSmallSize,
    disabled,
    isLoading,
    type = ButtonTypes.BUTTON,
    autoFocus,
  },
  ref,
) {
  return (
    <styledElements.Button
      ref={ref}
      onClick={onClick}
      style={styleProps}
      buttonVariant={variant}
      centerText={centerText}
      hasLeftIcon={!!leftIconProps}
      isSmallSize={isSmallSize}
      disabled={disabled}
      disabledVariant={disabled}
      isLoading={isLoading}
      type={type}
      autoFocus={autoFocus}
    >
      {isLoading && <LoadingIcon />}
      {leftIconProps && <ButtonIcon iconProps={leftIconProps} />}
      <span>{label}</span>
      {rightIconProps && <ButtonIcon iconProps={rightIconProps} isRightIcon />}
    </styledElements.Button>
  );
});

export default Button;
